/* Publish by EComposer at 2026-10-06 07:56:50*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-x55gnkguv0t"]=  window.__ectimmers["ecom-x55gnkguv0t"] || {};
var e=this.$el;if(e&&this.isLive){var t=e.querySelectorAll(".element-social-link:not(.element-social-link__custom)");t.length&&t.forEach(function(i){var a=i.getAttribute("href")||"#",r=a.replace("{current-link}",location.href);i.setAttribute("href",r)})}

                    });
                    
                        document.querySelectorAll('.ecom-x55gnkguv0t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x55gnkguv0t', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-bjgpdeq6fmn"]=  window.__ectimmers["ecom-bjgpdeq6fmn"] || {};
let e=this.$el.querySelector(".ecom-shopify__article__description-view-more-btn"),r=this.settings.content_type,s=this.$el.querySelector(".ecom-shopify__article__description--full"),l=this.$el.querySelector(".ecom-shopify__article__description--paragraph");e&&e.addEventListener("click",function(){r==="text"&&s?(s.style.display="inherit",l.style.display="none"):l.style.maxHeight=null,this.style.display="none"})

                    });
                    
                        document.querySelectorAll('.ecom-bjgpdeq6fmn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bjgpdeq6fmn', settings: {"content_type":"html"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}